import './PageNotFound.css'


const PageNotFound = () => {
    return (
        <div className="page-not-found">
            <h1>Page not found</h1>
            <p>Looks like you've taken a wrong turn!</p> 
            <p>Use the menu button to get back to the website.</p>
        </div>
    )
}

export default PageNotFound;